import { Users, BookOpen, UserCog, Briefcase, Globe, Calendar, Activity, Monitor, Settings } from "lucide-react";

export const permissionCategories = [
  {
    category: "Student Management",
    icon: Users,
    permissions: [
      { key: "view_students", label: "View Students" },
      { key: "add_edit_students", label: "Add / Edit Students" },
      { key: "delete_students", label: "Delete Students" },
      { key: "manage_enrollments", label: "Manage Enrollments" },
    ],
  },
  {
    category: "Course & Batch Management",
    icon: BookOpen,
    permissions: [
      { key: "view_courses", label: "View Courses" },
      { key: "add_edit_courses", label: "Add / Edit Courses" },
      { key: "manage_syllabus", label: "Manage Syllabus" },
      { key: "manage_batches", label: "Manage Batches" },
      { key: "assign_instructors", label: "Assign Instructors" },
    ],
  },
  {
    category: "Instructor Management",
    icon: UserCog,
    permissions: [
      { key: "view_instructors", label: "View Instructors" },
      { key: "add_edit_instructors", label: "Add / Edit Instructors" },
      { key: "manage_schedules", label: "Manage Schedules" },
    ],
  },
  {
    category: "Fee Management",
    icon: Briefcase,
    permissions: [
      { key: "view_fees", label: "View Fees" },
      { key: "collect_payments", label: "Collect Payments" },
      { key: "manage_discounts", label: "Manage Discounts" },
      { key: "generate_invoices", label: "Generate Invoices" },
    ],
  },
  {
    category: "Enquiry Management",
    icon: Globe,
    permissions: [
      { key: "view_enquiries", label: "View Enquiries" },
      { key: "add_edit_enquiries", label: "Add / Edit Enquiries" },
      { key: "convert_to_student", label: "Convert to Student" },
    ],
  },
  {
    category: "Assessments & Interviews",
    icon: Calendar,
    permissions: [
      { key: "manage_interviews", label: "Manage Interviews" },
      { key: "schedule_interviews", label: "Schedule Interviews" },
      { key: "manage_assignments", label: "Manage Assignments" },
      { key: "view_ai_attempts", label: "View AI Attempts" },
    ],
  },
  {
    category: "Reports & Analytics",
    icon: Activity,
    permissions: [
      { key: "view_reports", label: "View Reports" },
      { key: "view_dashboards", label: "View Dashboards" },
      { key: "export_data", label: "Export Data" },
    ],
  },
  {
    category: "Settings",
    icon: Settings,
    permissions: [
      { key: "settings_general", label: "General Settings" },
      { key: "settings_notifications", label: "Notification Settings" },
      { key: "settings_branding", label: "Branding Settings" },
      { key: "settings_payments", label: "Payment Settings" },
      { key: "settings_zoom", label: "Zoom Settings" },
    ],
  },
  {
    category: "System & Administration",
    icon: Monitor,
    permissions: [
      { key: "manage_admins", label: "Manage Admins" },
      { key: "send_notifications", label: "Send Notifications" },
      { key: "access_audit_logs", label: "Access Audit Logs" },
    ],
  },
];

export const TOTAL_PERMISSIONS = permissionCategories.reduce(
  (sum, c) => sum + c.permissions.length, 0
);

export const ALL_PERMISSION_KEYS = permissionCategories.flatMap(
  (c) => c.permissions.map((p) => p.key)
);

export const ROLE_OPTIONS = ["Super Admin", "Admin", "Moderator"];

export const DEPARTMENT_OPTIONS = ["IT", "Admin", "HR", "Academics", "Finance", "Marketing"];
